'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalContent = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PortalContent = exports.PortalContent = function (_Component) {
  (0, _inherits3.default)(PortalContent, _Component);

  function PortalContent() {
    (0, _classCallCheck3.default)(this, PortalContent);
    return (0, _possibleConstructorReturn3.default)(this, (PortalContent.__proto__ || (0, _getPrototypeOf2.default)(PortalContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(PortalContent, [{
    key: 'render',
    value: function render() {
      if (!__CLIENT__) {
        return false;
      }

      var _props = this.props,
          id = _props.id,
          children = _props.children;


      var domNode = document.querySelector('[data-portal-id=\'' + id + '\']');

      if (!domNode) {
        return false;
      }

      return _reactDom2.default.createPortal(children, domNode);
    }
  }]);
  return PortalContent;
}(_react.Component);

PortalContent.propTypes = {
  id: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};